import Vue from 'vue';
import api from '../../api'

const state = {
  total: 0,
  page: 1,
  limit: 100,
  results: [],
};


const getters = {

  getTotalLogs(state) {
    return state.total
  },

  getActivePage(state) {
    return state.page
  },

  getActiveLimit(state) {
    return state.limit
  },

  getPageResults(state) {
    return state.results
  },

};

const mutations = {

  setPage(state, response) {
    Vue.set(state, 'total', response.total);
    Vue.set(state, 'page', response.page);
    Vue.set(state, 'limit', response.limit);
    Vue.set(state, 'results', response.results);
  }

};

const actions = {

  listLogs(ctx, request) {
    api.listLogs(
      {page: request.page || 1, limit: request.limit || 100},
      data => {
        ctx.commit('setPage', data)
      }
    );
  }

};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/logs.js